<template>
    <div>
        <loader-component v-if="isSendingDataToServer"></loader-component>
        <loader-component v-if="showLoader"></loader-component>
        <div v-else>
            <!-- responsive-header -->
            <responsive-header-component></responsive-header-component>
            <!-- responsive-header -->

            <div class="wrapper default">

                <!-- header -->
                <header class="main-header default">
                    <div class="container">
                        <header-component></header-component>
                    </div>
                    <navbar-component></navbar-component>
                </header>
                <!-- header -->
                <!----------------------------------------------------------------------------------------->
                <!-- main -->
                <main class="single-product default">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <article class="product">
                                    <div class="row">
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="product-gallery default">
                                                <img :src="productInfo.PicPath" width="400" @error="imageLoadOnError" :alt="productInfo.Name" :title="productInfo.Name" />
                                            </div>
                                        </div>
                                        <div class="col-lg-8 col-md-8 col-sm-12">
                                            <div class="product-title">
                                                <h1>
                                                    {{productInfo.Name}}
                                                    <span>{{productInfo.ShortName}}</span>
                                                </h1>
                                            </div>
                                            <div class="review-main">
                                                <div :class="{ loader: !isShowSppiner }" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%">
                                                    <img style="position:absolute;top:40%;left:46%;z-index:100" src="/assets/img/loader/loader.svg" />
                                                </div>
                                                <form @submit.prevent="Addreview">
                                                    <div class="col-sm-12 col-md-12 pull-right">
                                                        <div class="form-account-title">عنوان نظر شما (اجباری)</div>
                                                        <div class="form-account-row">
                                                            <input name="Title" v-model="reviewInfo.Title" v-validate="{ required: true}" data-vv-as="عنوان نظر شما" class="input-field" placeholder="عنوان نظر خود را بنویسید">
                                                            <span class="error">{{ errors.first('Title') }}</span>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12 col-md-12 pull-right">
                                                        <div class="form-account-title">متن نظر شما (اجباری)</div>
                                                        <div class="form-account-row">
                                                            <textarea name="Text" v-model="reviewInfo.Text" v-validate="{ required: true,min:10}" data-vv-as="متن نظر شما" rows="3" class="input-field" placeholder="متن نظر خود را بنویسید"></textarea>
                                                            <span class="error">{{ errors.first('Text') }}</span>
                                                        </div>
                                                    </div>
                                                    <div class="btn-add">
                                                        <button type="submit" class="dk-btn dk-btn-info">
                                                            ثبت نظر
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </article>
                            </div>
                        </div>
                    </div>
                </main>
                <!-- main -->
                <!--Modal-->
                <div class="modal fade" id="reviewModal" tabindex="-1" role="dialog" aria-labelledby="reviewModal" aria-hidden="true">
                    <div class="modal-dialog" role="alertdialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <!--<h5 class="modal-title" id="exampleModalLabel">پیام</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>-->
                            </div>
                            <div class="modal-body">
                                <div class="row content-main-post">
                                    <div class="content-review col-md-12 col-xs-12">
                                        <div class="div-img"><img src="/assets/img/check.svg" /></div>
                                        <div class="text-succses"><p>نظر شما ثبت گردید و پس از تأیید در وب سایت نمایش داده خواهد شد.</p></div>
                                    </div>
                                </div>

                            </div>
                            <div class="btn-main">
                                <button @click="closeModal" type="button" class="dk-btn dk-btn-success">تأیید</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!--Modal-->
                <!------------------------------------------------------------------------------------------>
                <footer-component></footer-component>
                <footer-fixnav-component></footer-fixnav-component>
            </div>
        </div>

    </div>
</template>


<script>
    import { httpPromise } from "../../module/httpUtility";
    import { initialSite } from "../../module/initialSite";
    export default {
        data() {
            return {
                showLoader: false,
                isSendingDataToServer: false,
                isShowSppiner: false,
                reviewInfo: {},
                productInfo: {}
            }
        },
        beforeMount: function () {
            initialSite(this);
            this.sendToServer()
        },
        methods: {
            sendToServer() {
                this.isSendingDataToServer = true;
                this.scrollTop();
                httpPromise(this, '/v1/ProductManagement/ProductInformation/ReadBasic', 'get', { ProductId: this.$route.params.productId },
                    response => {
                        this.productInfo = response.data.Value;
                        createPageTitle('افزودن نظر به'+' ' + response.data.Value.Name);
                        this.isSendingDataToServer = false;
                    },
                    response => {
                        this.isSendingDataToServer = false;
                    }
                );
            },
            scrollTop() {
                $(function () {
                    $('html, body').animate({ scrollTop: 0 }, 800, 'easeInExpo');
                });
            },
            imageLoadOnError(event) {
                event.target.src = "/assets/img/no-image-available.png";
            },
            Addreview() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.isShowSppiner = true;
                        this.reviewInfo.ProductId = this.$route.params.productId;
                        httpPromise(this, '/v1/ProductManagement/ProductReviews/Add', 'post', JSON.stringify(this.reviewInfo),
                            response => {
                                toastr.remove();
                                this.reviewInfo = {};
                                this.isShowSppiner = false;
                                $(function () {
                                    $('#reviewModal').modal({ backdrop: 'static', keyboard: false });
                                    $('#reviewModal').modal('show');
                                });
                            },
                            response => {
                                toastr.remove();
                                toastr.error(response.data.Message);
                                this.reviewInfo = {};
                                this.isShowSppiner = false;
                            });
                    }
                });
            },
            closeModal() {
                var component = this;
                $(function () {
                    $('#reviewModal').modal('hide');
                    component.$router.push({ name: 'product', params: { productId: component.productInfo.Id, productName: component.productInfo.Name } })
                });

            }
        }
    }
</script>

<style scoped>
    .dk-btn {
        padding: 12px 37px;
    }

    .modal-body, .btn-main {
        padding: 25px;
    }

    .btn-main {
        text-align: center;
    }

    .content-review img {
        width: 120px;
    }

    .content-review .div-img {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 25px;
    }

    .content-review .text-succses {
        text-align: center;
    }

        .content-review .text-succses p {
            font-size: 15px;
        }

    a:hover, a:focus {
        color: #fff;
    }

    .btn-add {
        text-align: center;
    }

        .btn-add .dk-btn {
            padding: 12px 38px;
            overflow: hidden;
        }

    .input-field {
        padding: 11px 11px 11px 11px;
    }

    .review-main {
        margin-top: 20px;
    }

    .product-gallery {
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>